import DropdownTemplateView from '../../../DropdownTemplateView'
import ScrollableContainer from '../../../util/ScrollableContainer'
import {connect} from '../../../redux/utils'
import {bindActionCreators} from 'redux'
import {getCountries, getDefaultTimeZoneCountry} from '../selectors'
import $ from 'jquery'
import {openPreviewHolidaysPanelByFileImport, openPreviewHolidaysPanelBySelectedCountry} from './panels/importHolidays/actions'
import {CountriesList} from './CountriesList'
import {validateFile} from '../utils'
import LoadingContainer from '../../../util/LoadingContainer'

class ImportHolidaysDialog extends DropdownTemplateView {
    constructor({
        onCountrySelected = countryId => {},
        importFromFile = () => {},
        onHide = () => {},
    }) {
        super(null, {
            onHide
        })

        this.actions = {
            onCountrySelected,
            importFromFile,
        }

        this.state = {
            defaultTimeZoneCountry: null,
            countries: [],
        }

        this.onStateChanged(state => {
            this.countriesList.setState({
                ...state,
                loading: state.countries.length <= 0
            })
        })
    }

    templateHtml() {
        return '<div class="components_importHolidaysDialog">' +
               '    <div class="title">' +
               '        <div class="text"><%=title%></div>' +
               '    </div>' +
               '    <div class="countriesContainer"/>' +
               '    <div class="importLinkContainer">' +
               '        <input type="file" class="importFileInput" hidden>' +
               '        <div class="importFileLink"><%=importFileLink%></div>' +
               '    </div>' +
               '</div>'
    }

    messageKeys() {
        return {
            title: 'work_schedule.import_holidays_dialog.title',
            importFileLink: 'work_schedule.import_holidays_dialog.import_file_link',
        }
    }

    afterRender() {
        this.countriesList = new LoadingContainer({
            contentComponent: new ScrollableContainer(null,
                new CountriesList({
                    onCountrySelected: country => {
                        this.hide()
                        this.actions.onCountrySelected(country)
                    },
                }),
                {
                    containerClass: 'countriesContainerScrollableWrapper',
                }
            ),
            containerClass: "loading_importHolidaysDialog",
        }).init(this.find('.countriesContainer'))

        this.$fileInput = this.find('.importFileInput').on('change', () => {
            if (this.$fileInput[0].files.length !== 0) {
                let file = this.$fileInput[0].files[0]
                let error = validateFile(file)
                if (error) {
                    alert(error)
                    this.$fileInput.val('')
                } else {
                    this.actions.importFromFile(this.$fileInput[0].files[0])
                    this.$fileInput.val('')
                }
            }
        })

        this.find('.importFileLink').on('click', () => {
            this.hide()
            this.$fileInput.click()
        })

        this.renderInitialState()
        this.getEl().on('click', e => e.stopPropagation())
    }
}

const ImportHolidaysDialogConnected = connect(
    (state) => ({
        defaultTimeZoneCountry: getDefaultTimeZoneCountry(state),
        countries: getCountries(state),
    }),
    (dispatch) => ({
        onCountrySelected: bindActionCreators(openPreviewHolidaysPanelBySelectedCountry, dispatch),
        importFromFile: bindActionCreators(openPreviewHolidaysPanelByFileImport, dispatch),
    })
)(ImportHolidaysDialog)

let instance = null

export const getInstance = () => {
    if (!instance) {
        instance = new ImportHolidaysDialogConnected().init($('body'))
    }
    return instance
}


// WEBPACK FOOTER //
// ./web/js/administration/workSchedule/components/ImportHolidaysDialog.js